const CHART_CONFIGURATION = await import(`@/assets/env/${process.env.VUE_APP_CLIENT}/config_chart.json`);
export default CHART_CONFIGURATION.default as ChartsConfig;

export interface ChartsConfig {
    [survey_name: string]: ChartConfig 
}

export interface ChartConfig {
    line_x_label: string;
    line_y_label: string;
}

export function getChartConfig(survey_name: string): ChartConfig | undefined  {
    let config = CHART_CONFIGURATION.default as ChartsConfig;

    return config[survey_name];
}